import React from 'react'

import { Pagination as AntPagination } from 'antd'
import { useFormikContext } from 'formik'

interface PaginationProps {
  defaultPage: number
  defaultPageSize: number
  total: number
  onChange?: (page: number, pageSize: number) => void
  hideOnSinglePage?: boolean
}

const Pagination: React.FC<PaginationProps> = (props) => {
  const context = useFormikContext()

  const onChange = (page: any, pageSize: any) => {
    if (page <= 1) {
      context.setFieldValue('page', 0)
      context.setFieldValue('pageSize', 10)
    } else {
      context.setFieldValue('page', page)
      context.setFieldValue('pageSize', pageSize)
    }
  }
  return (
    <>
      <AntPagination
        defaultCurrent={props.defaultPage}
        defaultPageSize={props.defaultPageSize}
        total={props.total}
        onChange={props.onChange ?? onChange}
        hideOnSinglePage={props.hideOnSinglePage}
      ></AntPagination>
    </>
  )
}
export default Pagination
